export enum recognition_options {
    "Acceso",
    "Inicial",
    "Temprano",
    "Avanzado",
    "Experto 1",
    "Experto 2"
}
